export const environment = {
  production: true,
  apiUrl: 'https://www.cantine.wine/api2/',
  hostUrl: 'https://www.cantine.wine/',
  stripePublishable: 'pk_live_XvSdDn69HgGMrSEEaZXepsdV'
};